import CloseIcon from '@mui/icons-material/Close';
import { FormControl, Modal } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../../theme';

export const CloseIconModalStyled = styled(CloseIcon)`
    && {
        position: absolute;
        right: 16px;
        top: 16px;
        cursor: pointer;
        padding: 8px;
        transition: color 400ms ease-in-out;
        &:hover {
            color: ${colors.grey100};
            transition: color 400ms ease-in-out;
        }
    }
`;

export const LineChartModalHeaderStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    /* Keeps the dropdown clear of the close icon in the top right corner. */
    padding-right: 40px;
`;

export const TemporalitySelectFormControlStyled = styled(FormControl)`
    && {
        min-width: 180px;
        margin-top: -8px;
    }
`;

export const ModalStyled = styled(Modal)`
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
`;
